import type { RenterPaymentSubscriptionInterface, RenterPaymentSubscriptionNumericInputInterface } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

const PaymentSubscriptionModel = (
  paymentSubscriptionDetails: RenterPaymentSubscriptionNumericInputInterface,
): RenterPaymentSubscriptionInterface => {
  const {
    amount = 0,
    firstScheduledDate = 0,
    nextArrivalDate = 0,
    nextScheduledDate = 0,
    recurring,
    paymentMethodId = '',
  } = paymentSubscriptionDetails || {};

  return {
    amount: amount && Number(amount),
    firstScheduledDate: formatTimestampToYMDString(firstScheduledDate),
    nextArrivalDate: formatTimestampToYMDString(nextArrivalDate),
    nextScheduledDate: formatTimestampToYMDString(nextScheduledDate),
    recurring,
    paymentMethodId,
  };
};

export default PaymentSubscriptionModel;
